import ButtonType1 from "../../../components/ButtonType1/ButtonType1";
import ButtonType2 from "../../../components/ButtonType2/ButtonType2";


const Cover = () => {
    return (
        <div className="flex flex-col-reverse md:flex-row md:justify-between items-center">

            <div className="w-full md:max-w-[47%]">
                <h1 className="mb-6 font-[600] text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl">
                    Discover, collect,  and charity in extraordinary NFT marketplace
                </h1>
                <p className="mb-8 font-[400] text-base lg:text:lg 2xl:text-xl text-[#E2E2E2] tracking-[0.5px]">
                    In aenean posuere lorem risus nec. Tempor tincidunt aenean purus purus vestibulum nibh mi venenatis
                </p>
                <div className="flex items-center">
                    <ButtonType2 type="link" title="Explore" href="/collections" className="mr-6 w-[200px] px-6 py-3" />
                    <ButtonType1 type="link" title="Create" href="/create" className="w-[200px] px-6 py-3" />
                </div>
            </div>

            <div className="mb-10 md:mb-0 md:max-w-[47%]">

                <div className="flex flex-col p-5 border-blue-400 border-[1px] rounded-[8px] shadow-shadow6">
                    <div className="w-full max-w-[70vw] sm:max-w-[350px] md:max-w-[400px]">
                        <img alt="art" className="w-full rounded-[8px]" 
                            src = 'https://media.giphy.com/media/gF1ZgW5t8D8iDOoo8x/giphy.gif' />
                    </div>

                    <div className="flex justify-between items-center mt-6">
                        <div className="flex">
                            <img className="w-[50px] h-[50px] rounded-[50%] mr-3" alt="profilepic"
                                src = 'https://images.unsplash.com/photo-1570569977384-be17f90f1a10?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                            <div className="flex flex-col">
                                <p className="text-white">
                                    Laura
                                </p>
                                <p className="text-[#D7D7D7] tracking-wider">
                                    0.21 Weth
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <p className="text-white">
                                We are here
                            </p>
                            <p className="text-[#D7D7D7] tracking-wider">
                                ♡ 25
                            </p>
                        </div>
                    </div>  

                </div>
            </div>

        </div>
    )
}

export default Cover;